import { useState } from "react";
import { useSelector } from "react-redux";
import "./AddVanLicense.css";

const AddVanLicense = ({ getLicenseData, show, handleClose }) => {
  const [licenseTypes, setLicenseTypes] = useState([]);
  // const [licensePhoto, setLicensePhoto] = useState(null);

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // const [addMainCatigory, setAddMainCatigory] = useState({
  //   image: "",
  //   description: "",
  //   name: "",
  //   status: "",
  // });

  // const [show, setShow] = useState(false);

  // const handleShow = () => {
  //   setAddMainCatigory({
  //     image: "",
  //     fileUrl: "",
  //     name: "",
  //     description: "",
  //     status: "",
  //   });
  //   // setIsEditing(false);
  //   // setEditCategoryId(null);
  //   setShow(true);
  // };

  // const handleClose = () => {
  //   setShow(false);
  //   // setIsEditing(false)
  //   // setEditCategoryId(null);
  // };

  //  const getLicenseTypes = async ()=>{
  //   try {
  //     let response = await axios.get(`${baseUrl}/api/license_types` , {
  //       headers:{Authorization:`Bearer ${token}`},
  //     });
  //     console.log(response.data.data.license_types);
  //     setLicenseTypes(response.data.data.license_types);
  //   } catch (error) {
  //     console.error("Error fetching license types:", error.message);
  //   }
  // };

  // useEffect(() => {
  //   getLicenseTypes();
  // }, []);

  return <p>ggg</p>;
};

export default AddVanLicense;
